
import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import KhAlert from '../../Components/Alert/KhAlert';
import { UserInfokh } from '../../Contexts/UserContext';
import { ApiURL } from '../../App';

const EditRefrigeratorSale = () => {

    const queryParameters = new URLSearchParams(window.location.search);  // to get Id form url
    const Id = queryParameters.get("Id"); 
    
    const userInfo_Now =useContext(UserInfokh);
    const [loading,setloadnig]=useState(true);
    const [alert_,SetAlert]=useState({Activate:false,msg:''});
    const [flag,Setflag]=useState(false);
    const navigate =useNavigate();
    const [formData, setFormData] = useState({
      id:0,
      buyerName:'',
      customerName:'',
      totalWeightAfterDiscount_2Percent:0,
      totalWeightAfterDiscount_2Percent2:'',
      totalSalesPriceOfAll:0,
      totalSalesPriceOfAll2:'',
      priceResult:0,
      date:'08/08/2025'
    });
  
    useEffect(()=>{

        const fetchData = async () => {
            setloadnig(true);
            try {
            const res=  await axios.get(ApiURL+'RefrigeratorSale/GetRefSaleById?id='+Id,{   
              headers:{
                'Accept': 'text/plain',
                'Content-Type': 'application/json',
                'Authorization': `bearer ${userInfo_Now.auth.token}`
              }
              });
             
             const date = new Date(res.data.date);
              const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
              const formattedDate = localDate.toISOString().split('T')[0];
              res.data.date=formattedDate;
              setFormData(res.data);
              setloadnig(false);                  
              }
              catch(err)
              {
                SetAlert({Activate:true,msg:'تأكد من الاتصال بالانترنت'});
                setloadnig(false);               
              }
          
          };
         
            fetchData();
          
        },[]);
   
      const handleChange = (name, value) => {
        
        setFormData({
          ...formData,
          [name]: value
        });        
      };

      const handleSubmit = async (e) => {
        Setflag(true);
        if(!(formData.customerName.length<1 ||formData.totalWeightAfterDiscount_2Percent2<1||formData.totalSalesPriceOfAll2<1))
        {
          setloadnig(true);
          try {
          const res = await axios.post(ApiURL+'RefrigeratorSale/UpdateRefSales', formData, {
            headers: {
              'Accept': 'text/plain',
              'Content-Type': 'application/json',
               'Authorization': `bearer ${userInfo_Now.auth.token}`
            }
           
          });
          setloadnig(false);
          navigate('/allRefrigeratorsSale');
          navigate(0);
          
        } catch (error) {      
          SetAlert({Activate:true,msg:'تأكد من الاتصال بالانترنت'});
          setloadnig(false);
        }
        }
      };

    return (
        <>
         <KhAlert Kh_Active={alert_.Activate} msg={alert_.msg} func_setactive={SetAlert} />
            <div className='parent-Dmaterial'>
                <div className='child-Dmaterial'>
                <div className="mb-3"> 
              <label className="form-label">
              اسم التاجر 
              </label>
              <input
                className="form-control"
                type='text'
                name="buyerName"
                value={formData.buyerName}
							/>
             
            </div>
        <div className="mb-3"> 
          <label className="form-label">
              الجهة
              </label>
              <input
                className="form-control"
                type='text'
                name="customerName"
                value={formData.customerName}
                onChange={(e)=>{handleChange('customerName',e.target.value)}}
							/>
              {formData.customerName.length<2 &&flag&& ( <p className="validationReg"> *الرجاء إدخال الجهة  </p>)}
            </div>

            <div className="mb-3"> 
              <label className="form-label">
              الوزن الصافي
              </label>
              <input
                className="form-control"
                type="number"
                name="totalWeightAfterDiscount_2Percent"
                value={formData.totalWeightAfterDiscount_2Percent}
               
							/>
              
               </div>

               <div className="mb-3"> 
              <label className="form-label">
             الوزن الصافي الجديد
              </label>
              <input
                className="form-control"
                type="number"
                name="totalWeightAfterDiscount_2Percent2"
                value={formData.totalWeightAfterDiscount_2Percent2}
                onChange={(e)=>{handleChange('totalWeightAfterDiscount_2Percent2',e.target.value)}}
							/>
               {formData.totalWeightAfterDiscount_2Percent2<1 &&flag&& ( <p className="validationReg"> *الرجاء إدخال قيمة هنا   </p>)}
               </div>

               <div className="mb-3"> 
              <label className="form-label">
              السعر الكلي
              </label>
              <input
                className="form-control"
                type="number"
                name="totalSalesPriceOfAll"
                value={formData.totalSalesPriceOfAll}
               
							/>
              
               </div>

               <div className="mb-3"> 
              <label className="form-label">
              السعر الكلي الجديد
              </label>
              <input
                className="form-control"
                type="number"
                name="totalSalesPriceOfAll2"
                value={formData.totalSalesPriceOfAll2}
                onChange={(e)=>{handleChange('totalSalesPriceOfAll2',e.target.value)}}
							/>
               {formData.totalSalesPriceOfAll2<1 &&flag&& ( <p className="validationReg"> *الرجاء إدخال قيمة هنا   </p>)}
               </div>
           
            <div className="mb-3">
              <label className="form-label">
                التاريخ
              </label>
              <input
                className="form-control"
                type="text"
                name="date"
                value={formData.date}
              />
              
            </div>
           
       
        <button className='btn-Add' onClick={()=>{handleSubmit()}} >تعديل</button>
                </div>
            </div>
             {loading && <div className='loader-parent'> <div className="loader"></div></div>}
        </>
    );
}

export default EditRefrigeratorSale;
